"use client"

import { Button, Text } from "@/elements"
import { UnauthorizedPageContainer } from "../UnauthorizedPageContainer"

export const ErrorPage = () => {
  return (
    <UnauthorizedPageContainer className="flex-1 px-3">
      <div className="flex h-full w-full flex-1 flex-col items-center justify-center">
        <Svg404 />
        <div className="my-4">
          <Text className="text-center" variant="h5">
            We&apos;re sorry, we couldn&apos;t find this page.
          </Text>
        </div>
        <Button onClick={() => (window.location.href = "/")}>Go home</Button>
      </div>
    </UnauthorizedPageContainer>
  )
}

const Svg404: React.FC = ({}) => (
  <svg width="203" height="88" viewBox="0 0 203 88" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M53.96 2.49999V56.62H66.08L63.44 69.82H53.96V86.5H39.44V69.82H10.28C4.88 69.82 0.32 66.46 0.32 60.58C0.32 58.42 0.56 55.66 2.84 52.54L38.48 2.49999H53.96ZM39.68 21.58L15.68 56.62H39.68V21.58ZM102.201 87.94C86.7209 87.94 73.4009 76.78 73.4009 59.62V29.38C73.4009 12.22 86.7209 0.939993 102.201 0.939993C117.921 0.939993 131.001 12.22 131.001 29.38V59.62C131.001 76.78 117.921 87.94 102.201 87.94ZM102.201 73.9C110.001 73.9 115.761 68.02 115.761 59.86V29.14C115.761 20.98 110.001 14.98 102.201 14.98C94.5209 14.98 88.6409 20.98 88.6409 29.14V59.86C88.6409 68.02 94.5209 73.9 102.201 73.9ZM190.371 2.49999V56.62H202.491L199.851 69.82H190.371V86.5H175.851V69.82H146.691C141.291 69.82 136.731 66.46 136.731 60.58C136.731 58.42 136.971 55.66 139.251 52.54L174.891 2.49999H190.371ZM176.091 21.58L152.091 56.62H176.091V21.58Z"
      fill="url(#paint0_linear_766_105)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_766_105"
        x1="40.2837"
        y1="19.4136"
        x2="157.119"
        y2="115.283"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#BA85FF" />
        <stop offset="1" stopColor="#E785FF" stopOpacity="0.59" />
      </linearGradient>
    </defs>
  </svg>
)
